export enum UserSortType {
  'ALPHABETICALLY' = 'ALPHABETICALLY',
  'CREATION' = 'CREATION',
}
